export default defineNuxtRouteMiddleware(to => {
  const { id: userId, isSsoSetupIncomplete } = storeToRefs(useUserStore())

  if (userId.value && isSsoSetupIncomplete.value && to.path !== '/signup/sso') {
    return navigateTo('/signup/sso')
  }
})
